import React, { useState, useEffect } from 'react'
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import '../App.css';
import axios from 'axios';
import AddShiftPopup from './AddShiftPopUp';
import CopyShiftPopUp from './CopyShiftPopUp';
import LoginRequest from './LoginRequest';
import moment from 'moment'
import {
  SERVER_URI
} from "../utility/config";

require("moment/locale/fi")

function ShiftCalendar(props) {
  //props.stopListRefresh()
  const [driverList, setDriverList] = useState([]);
  const [workList, setWorkList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCopy, setIsOpenCopy] = useState(false);
  const [isloggedIn, setIsloggedIn] = useState(true);
  const [isShiftPopUpOpen, setIsShiftPopUpOpen] = useState(false);
  const [selectedShift, setSelectedShift] = useState(null);
  let dispatch = props.dispatch
  let storage = window.localStorage;
  let userToken = storage.getItem("admin_token")

  useEffect(() => {
    const fetchData = async () => {
      let driverList = props.driverList
      let workList = props.workList
      let vehicleList = props.vehicleList
      if (userToken === null) {
        console.log("kirjaudu sisään")
        setIsloggedIn(false)
      } else {
        for (let i = 0; i < workList.length; i++) {
          workList[i].shiftStarts = moment(workList[i].shiftStarts).toDate();
          workList[i].shiftEnds = moment(workList[i].shiftEnds).toDate();
        }
        workList = workList.map((work) => ({...work, vehicleId: String(work.vehicleId) }))
        setWorkList(workList)
        setDriverList(driverList)
        setVehicleList(vehicleList)
      }
    }
    fetchData();
    // DON'T DELETE THE COMMENT BELOW!!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.workList])

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }

  const togglePopUpCopy = async () => {
    setIsOpenCopy(!isOpenCopy)
  }

/*  const onSelectEvent = (pEvent) => {
    console.log("Selected event:", pEvent)
    const confirmDelete = window.confirm("Poistetaanko valittu vuoro?")
    const reservedShiftId = pEvent.reservedShiftId
    let storage = window.localStorage;
    let userToken = storage.getItem("admin_token")

    if (confirmDelete === true) {
      axios.delete(`${SERVER_URI}/remove_reserved_work_shift/${reservedShiftId}`, { headers: { "Authorization": `Token ${userToken}` } })
        .catch(function (error) {
          console.log(error);
        });
      const events = [...workList]
      const shiftIndex = events.indexOf(pEvent)
      events.splice(shiftIndex, 1);
      setWorkList(events)
      dispatch({ type: "DELETE_WORKSHIFT", data: { workIndex: shiftIndex } })
    }
  }*/

  const handleOpenShiftPopUp = (event) => {
    setSelectedShift(event);
    setIsShiftPopUpOpen(true);
  }

  const TitleComponent = (event) => {
    return (
      <div>
        <span>Työvuoro</span><br />
        <span>  Ajoneuvon Id: {event.event.vehicleId} </span>
      </div>

    )
  }
  const localizer = momentLocalizer(moment)
  return (<div className="calendar-container">
    <>
      <h4>Vuorokalenteri</h4>
      <button id="CalendarButton" onClick={togglePopUp} >Lisää työvuoroja</button>
      <button id="CalendarButton" onClick={togglePopUpCopy} >Kopioi työvuoroja</button>
      <Calendar
        showMultiDayTimes={true}
        popup
        localizer={localizer}
        events={workList}
        components={{
          event: TitleComponent
        }}
        defaultView={Views.MONTH}
        views={['month', 'day', 'week']}
        step={60}
        timeslots={1}
        messages={{
          month: "Kuukausi",
          day: "Päivä",
          next: "Seuraava",
          previous: "Edellinen",
          today: "Tänään",
          week: "Viikko",
          title: "Auton id:"
        }}

        min={new Date(0, 0, 0, 0, 0, 0)}
        scrollToTime={new Date(1970, 1, 1, 6)}
        defaultDate={new Date()}
        onSelectEvent={event => handleOpenShiftPopUp(event)} //Fires selecting existing event
        resources={vehicleList}
        resourceAccessor='vehicleId'
        resourceIdAccessor='vehicleId'
        resourceTitleAccessor='vehicleId'
        startAccessor='shiftStarts'
        endAccessor='shiftEnds'
        titleAccessor='vehicleId'
      />
      {isShiftPopUpOpen && (
        <ShiftPopUp handleClose={() => setIsShiftPopUpOpen(false)} shift={selectedShift} dispatch={props.dispatch}  />
      )}
      {isOpen && (
        <AddShiftPopup dispatch={dispatch} handleClose={togglePopUp} vehicleList={vehicleList} driverList={driverList} />
      )}
      {isOpenCopy && (
        <CopyShiftPopUp dispatch={dispatch} handleClose={togglePopUpCopy} workList={workList} />
      )}
      {!isloggedIn && <LoginRequest />}
    </>
  </div>
  )
}

function formatTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
}

function convertLocalTimeToUtcString(localTime, date) {
  // We need to take the local time date and combine it with the local time string
  const today = moment(date).format('YYYY-MM-DD'); // Get the date part in YYYY-MM-DD format
  const localDate = new Date(`${today}T${localTime}`);
  // Convert to UTC and return whole date string
  return localDate.toISOString()
}

const ShiftPopUp = (props) => {
  const { shift } = props;
  const [startTime, setStartTime] = useState(formatTime(shift?.shiftStarts));
  const [endTime, setEndTime] = useState(formatTime(shift?.shiftEnds));
  const dispatch = props.dispatch;

  console.log("Shift:", shift);

  const handleSubmitChanges = async (e) => {
    e.preventDefault();
    // Get start and end dates from the shift object
    const startDate = shift.shiftStarts;
    const endDate = shift.shiftEnds;
    // Convert local times to UTC strings
    const startTimeUtc = convertLocalTimeToUtcString(startTime, startDate);
    const endTimeUtc = convertLocalTimeToUtcString(endTime, endDate);

    const reservedShiftId = shift.reservedShiftId;
    const driverId = shift.driverId;
    const vehicleId = shift.vehicleId;
    try{
      await axios({
        method: "PUT",
        url: `${SERVER_URI}/update_reserved_shift/`,
        data: {
          reservedShiftId: reservedShiftId,
          driverId: driverId,
          vehicleId: vehicleId,
          startTime: startTimeUtc,
          endTime: endTimeUtc
        },
        headers: { Authorization: `Token ${window.localStorage.getItem("admin_token")}` }
      })
      const updatedShift = {
        ...shift,
        shiftStarts: new Date(startTimeUtc),
        shiftEnds: new Date(endTimeUtc),
      }
      dispatch({ type: "UPDATE_WORKSHIFT", data: { updatedShift } })
      props.handleClose();
      alert("Työvuoro päivitetty onnistuneesti.");
    } catch(err) {
      console.error("Error updating shift:", err);
      alert("Työvuoron päivittäminen epäonnistui. Tarkista konsoli virheiden varalta.");
    }
  }

  const handleDeleteShift = async () => {
    const confirmDelete = window.confirm("Haluatko varmasti poistaa tämän työvuoron?")
    if (confirmDelete) {
      try {
        await axios.delete(`${SERVER_URI}/remove_reserved_work_shift/${shift.reservedShiftId}`, {
          headers: { Authorization: `Token ${window.localStorage.getItem("admin_token")}` }
        });
        dispatch({ type: "DELETE_WORKSHIFT", data: { workShiftId: shift.reservedShiftId} });
        props.handleClose();
      } catch (error) {
        console.error("Error deleting shift:", error);
        alert("Työvuoron poistaminen epäonnistui. Tarkista konsoli virheiden varalta.");
      }
    }
  }

  return (
    <div className="popUp_card">
      <div className="popup-box">
        <div className="box">
          <span className="close-icon" onClick={props.handleClose}>
            x
          </span>
          <h2 className="popUp_title">Muokkaa työvuoroa</h2>
          <div>
            Kuljettaja: {shift?.driverId}
            <br />
            Ajoneuvo: {shift?.vehicleId}
            <br />
            Päivämäärä: {moment(shift?.shiftStarts).format('DD.MM.YYYY')}
            <br />
            Aloitusaika:
            <input type="time" id="startTime" value={startTime} onChange={(e) => setStartTime(e.target.value)} required />
            <br />
            Lopetusaika:
            <input type="time" id="endTime" value={endTime} onChange={(e) => setEndTime(e.target.value)} required />
            <br />
            <button id="gradient_Button" onClick={e=>handleSubmitChanges(e)}>Tallenna</button>
            <button id="gradient_Button" onClick={handleDeleteShift}>Poista työvuoro</button>
          </div>
        </div>
      </div>
    </div>
  )
}

// TODO: State changes to reducer

export default ShiftCalendar